function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgHospitalIcon = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 30,
  height: 30,
  viewBox: "0 0 30 30",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h30v30H0z",
  style: {
    fill: "#596069",
    fillOpacity: 1,
    stroke: "none"
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.95 6.672c.073 0 .148-.004.222-.004h3.5q.526-.005 1.047-.004h1.429c.434 0 .817.008 1.192.246.281.29.265.582.262.961v1.18q.001.45-.004.902v1.305q.001 1.061-.004 2.117v2.184c-.004.21-.004.43-.004.64q-.001 2.637-.008 5.274h.52l.046-11.059c5.125 0 5.125 0 5.422.25.235.281.27.531.27.887v2.519q-.005.717-.004 1.434.001.92-.004 1.84v2.89c0 .098 0 .2-.004.297v.516c0 .156-.004.281-.055.426h1.325v1.843H2.902v-1.843H4.32v-.395q-.007-1.836-.008-3.676 0-.943-.003-1.886.001-.827-.004-1.649v-1.992q-.005-.21-.004-.414v-.121c.004-.235.031-.39.16-.594 1.3-1.242 3.59-.332 5.387-.332.02 3.652.035 7.3.05 11.059h.516v-.22c-.004-1.73-.008-3.452-.008-5.179v-.77q-.005-1.024-.004-2.054-.005-1.05-.004-2.105c0-.434 0-.872-.003-1.305V8.434q-.005-.276-.004-.559v-.164c.004-.371.058-.582.324-.856.37-.23.812-.187 1.234-.183m1.917.672c-.043.02-.086.035-.125.054-.828.375-1.32 1.063-1.633 1.891-.23.781-.093 1.625.286 2.336.433.727 1.152 1.219 1.96 1.434.782.152 1.524.02 2.207-.375.227-.153.418-.325.61-.52.031-.031.062-.055.094-.086.53-.555.734-1.316.73-2.062-.027-.832-.39-1.567-.988-2.133-.695-.625-1.5-.766-2.403-.735-.261.02-.496.09-.738.196m-8.18 5.246v1.18h1.184v-1.18zm1.891 0v1.18h1.184v-1.18zm13.988 0v1.18h1.184v-1.18zm1.891 0v1.18h1.184v-1.18zm-17.77 2.078v1.184h1.184v-1.184zm1.891 0v1.184h1.184v-1.184zm13.988 0v1.184h1.184v-1.184zm1.891 0v1.184h1.184v-1.184zM5.687 16.84v1.183h1.184V16.84zm1.891 0v1.183h1.184V16.84zm13.988 0v1.183h1.184V16.84zm1.891 0v1.183h1.184V16.84zm-10.113.144v4.442h3.547v-4.442zm0 0",
  style: {
    stroke: "none",
    fillRule: "nonzero",
    fill: "#fff",
    fillOpacity: 1
  }
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.242 8.195h1.516v1.133h1.176v1.559h-1.176v1.133h-1.516v-1.133h-1.176V9.328h1.176zm0 0",
  style: {
    stroke: "none",
    fillRule: "nonzero",
    fill: "#fff",
    fillOpacity: 1
  }
}));
export { SvgHospitalIcon as ReactComponent };
export default __webpack_public_path__ + "assets/images/hospitalIcon.svg";